import { render, staticRenderFns } from "./AuthenticationCallback.vue?vue&type=template&id=c8b31394&scoped=true"
import script from "./AuthenticationCallback.vue?vue&type=script&lang=js"
export * from "./AuthenticationCallback.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationCallback.vue?vue&type=style&index=0&id=c8b31394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b31394",
  null
  
)

export default component.exports